export default "__VITE_ASSET__Cd51lR$Y__"